<template>
	<div>
		<BaseHeader :title="$t('invitations').toString()">
			<BaseButton class="btn-blue" @click="$route.name !== 'invite' && $router.push({ name: 'invite' })">
				Einladen
			</BaseButton>
		</BaseHeader>

		<div class="main">
			<div>
				<div class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
								<table class="min-w-full divide-y divide-gray-200">
									<thead>
										<tr>
											<th
												v-for="header in getHeader"
												:key="header.name"
												:class="header.class"
												class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
											>
												{{ header.name }}
											</th>
										</tr>
									</thead>
									<tbody class="bg-white divide-y divide-gray-200">
										<InvitationRow v-for="invitation in invitations" :key="invitation.id" :invitation="invitation"> </InvitationRow>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<router-view />
		</div>
	</div>
</template>
<script>
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import EmployeeRow from '@/components/rows/EmployeeRow.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import InvitationsRepository from '@/api/repositories/InvitationsRepository';
import InvitationRow from '@/components/rows/InvitationRow.vue';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'InvitationsOverview',
	mixins: [Authentication],
	components: { InvitationRow, BaseButton, BaseHeader },

	data() {
		return {
			per_page: { display: '25', value: 25 },
			isLoading: false,
			invitations: [],
		};
	},
	mounted() {
		this.isLoading = true;
		this.getInvitations();
	},
	watch: {
		'$route.name'(newValue, oldValue) {
			if (oldValue === 'invite' && newValue === 'invitations') {
				this.getInvitations();
			}
		},
	},
	computed: {
		getHeader() {
			const header = [];
			header.push({ name: 'Firma', class: 'px-6' });
			header.push({ name: 'E-Mail', class: 'px-6' });
			header.push({ name: 'Status', class: 'px-6' });
			header.push({ name: 'Code', class: 'px-6' });
			header.push({ name: 'Aktionen', class: 'px-6' });

			return header;
		},
	},

	methods: {
		getInvitations() {
			new InvitationsRepository().getInvitations().then(response => {
				this.invitations = response.data;
			});
		},
	},
};
</script>
